import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { Icon } from "@equidefi/ui/icon";
import type React from "react";
import { Link } from "react-router";

import SectionButton from "./SectionButton";

export interface Crumb {
  label: string;
  to?: string;
}

interface VaultPageHeaderProps {
  /** Breadcrumb trail shown on desktop. The last crumb is the current page (no link). */
  crumbs: Crumb[];
  /** Target + label for the mobile back button. */
  backTo: string;
  backLabel: string;
}

/**
 * VaultPageHeader - Responsive navigation header for vault pages.
 *
 * Desktop renders a breadcrumb trail (blue underlined links); mobile renders a
 * single back button card. Shared by the investment hub and its subpages.
 */
export const VaultPageHeader: React.FC<VaultPageHeaderProps> = ({ crumbs, backTo, backLabel }) => {
  return (
    <>
      <Box display={{ base: "none", lg: "block" }} mb="6">
        <Breadcrumb separator={<Icon.ChevronRight size="1em" color="gray.400" />} spacing="2">
          {crumbs.map((crumb, index) => {
            const isCurrent = index === crumbs.length - 1;
            return (
              <BreadcrumbItem key={crumb.label} isCurrentPage={isCurrent}>
                {isCurrent || !crumb.to ? (
                  <Box as="span" fontWeight={isCurrent ? "bold" : "normal"} color="#171c2c">
                    {crumb.label}
                  </Box>
                ) : (
                  <BreadcrumbLink as={Link} to={crumb.to} color="equidefi.blue" textDecoration="underline">
                    {crumb.label}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            );
          })}
        </Breadcrumb>
      </Box>

      <Box display={{ base: "block", lg: "none" }}>
        <SectionButton to={backTo} iconDirection="left">
          {backLabel}
        </SectionButton>
      </Box>
    </>
  );
};

export default VaultPageHeader;
